import {useMutation} from "@tanstack/react-query";

import {addMaterialFunctionMutationOptions} from "./add-material-function.mutation-options";

export function useAddMaterialFunction(id: string) {
  return useMutation(addMaterialFunctionMutationOptions(id));
}
